// extracted by mini-css-extract-plugin
export default {"container":"container___aad7a76559e5913a","label":"label___b5fc48473b8193f6","agreementLink":"agreementLink___a15786194a2f7331"};